import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const PrivateRouteTodo = ({
  component: Component,
  auth: { todoisAuthenticated, todoloading },
  ...rest
}) => (
  <Route
    {...rest}
    render={props =>
      todoisAuthenticated ? <Component {...props} /> : <Redirect to="/todo/billing" />
    }
  />
);

PrivateRouteTodo.propTypes = {
  auth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth
});

export default connect(mapStateToProps)(PrivateRouteTodo);